import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getCurrentUser } from 'aws-amplify/auth';
import { ROUTES } from '../../../config';
import auth from '@common/auth';
import session from '@common/session';
import { PartnerSignInPage } from '../views/PartnerSignInPage';
import { InvestorRolesModel } from '@common/models/InvestorRoles';

export const PartnerSignInController: React.FC = () => {
  const navigate = useNavigate();
  const { getMyInvestorId } = InvestorRolesModel.getState();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const init = async () => {
      try {
        // If an auth session is active, redirect to the right place.
        await getCurrentUser();
        const investorId = await getMyInvestorId();
        if (investorId) {
          await session.start(investorId);
          navigate(ROUTES.dashboard);
        } else {
          navigate(ROUTES.createCitizenship);
        }
        return;
      } catch (err) {
        // Fall through
      }

      // Start the OIDC flow with the partner as the identiy provider.
      const identityProvider = searchParams.get('provider');
      auth.signInWithOIDC({ provider: { custom: identityProvider || '' } });
    };
    init();
  }, []);

  return <PartnerSignInPage />;
};
